export const isSigninCallbackPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('code') && urlParams.has('state');
};

export const isSignoutCallbackPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return !urlParams.has('code') && urlParams.has('state');
};
